import * as actions from './floor.actions';
import watch from './floor.operations';
import reducer, { initState } from './floor.reducers';

export { actions, watch, initState };

export default reducer;
